import {childMatcher} from "../matcher.js";

var find = Array.prototype.find;

function childFind(match) {
  return function() {
    return find.call(this.children, match);
  };
}

function childFirst() {
  return this.firstElementChild;
}

export default function(match) {
  return this.select(match == null ? childFirst
      : childFind(typeof match === "function" ? match : childMatcher(match)));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/selectChild.js
// module id = 691
// module chunks = 0